import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Directive({
  selector: '[appCopyOnHover]',
  standalone: true,
})
export class CopyOnHoverDirective {
  private _copyMode = false;

  @Input()
  public offset = 250;

  constructor(
    private readonly _elementRef: ElementRef,
    private readonly _renderer: Renderer2,
    private readonly _toastService: ToastrService,
  ) {}

  @HostListener('mouseover')
  public onMouseOver(): void {
    if (!this._copyMode) {
      const img = document.createElement('img');
      img.setAttribute('src', 'assets/images/pages/my-data/copy.png');
      img.setAttribute('width', '8.3px');
      img.setAttribute('height', '9.5px');
      img.setAttribute('id', 'copyElement');

      this._renderer.setStyle(img, 'margin-left', '5px');
      this._renderer.appendChild(this._elementRef.nativeElement, img);
      this._copyMode = true;

      document.getElementById('copyElement')?.addEventListener('click', () => {
        const val = this._elementRef.nativeElement.innerText;
        navigator.clipboard
          .writeText(val)
          .then(() => {
            this._toastService.success('Kod skopiowany do schowka', '', { timeOut: 2000 });
          })
          .catch(() => {
            console.error('Unable to copy text');
          });
      });
    }
  }

  @HostListener('click')
  public onClick(): void {
    if (!this._copyMode) {
      const img = document.createElement('img');
      img.setAttribute('src', 'assets/images/pages/my-data/copy.png');
      img.setAttribute('width', '8.3px');
      img.setAttribute('height', '9.5px');
      img.setAttribute('id', 'copyElement');

      this._renderer.setStyle(img, 'margin-left', '5px');
      this._renderer.appendChild(this._elementRef.nativeElement, img);
      this._copyMode = true;

      document.getElementById('copyElement')?.addEventListener('click', () => {
        const val = this._elementRef.nativeElement.innerText;
        navigator.clipboard
          .writeText(val)
          .then(() => {
            this._toastService.success('Kod skopiowany do schowka', '', { timeOut: 2000 });
            const img = document.getElementById('copyElement');

            if (img) {
              img?.remove();
              this._copyMode = false;
            }
          })
          .catch(() => {
            console.error('Unable to copy text');
          });
      });
    }
  }

  @HostListener('mouseleave')
  public onMouseOut(): void {
    if (this._copyMode) {
      const img = document.getElementById('copyElement');
      img?.remove();
      this._copyMode = false;
    }
  }
}
